<template>
    <div class="modal fade" id="book-modal" role="dialog">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <template v-if="schedule">
                        <h5>{{transEdit('book-manually') + ' ' + getDateTime(schedule.start)}}</h5>
                        <hr>
                    </template>
                </div>

                <div class="modal-body" style="overflow: visible !important; ">
                    <div v-if="customers.length && (! isLoadingCustomers)">
                        <div class="pb-3 px-3 font-weight-bold">{{transEdit('choose-customer')}}</div>
                        <vue-multiselect
                                v-model="selectedCustomer"
                                :options="customers"
                                track-by="id"
                                label="value"
                                :placeholder="transEdit('choose-customer')"
                        ></vue-multiselect>
                        <div v-if="selectedCustomerInformation && (! isLoadingCustomerData)">
                            <div class="p-3 font-weight-bold">{{transEdit('choose-treatment')}}</div>
                            <vue-multiselect
                                    v-model="selectedTreatment"
                                    :options="schedule.treatments"
                                    track-by="id"
                                    label="name"
                                    :placeholder="transEdit('treatment')"
                            ></vue-multiselect>

                            <div class="p-3" v-if="selectedTreatment">
                                <div v-if="hasCouponForTreatment">
                                    <div class="flex items-center mb-4">
                                        <input id="default-radio-1" type="radio" :value="false" v-model="createNewCoupon" class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600">
                                        <label for="default-radio-1" class="ms-2 ml-2 text-sm font-medium text-gray-900 dark:text-gray-300">{{transEdit('coupon-exists-should-use')}}</label>
                                    </div>
                                    <div class="flex items-center">
                                        <input checked id="default-radio-2" type="radio" :value="true" v-model="createNewCoupon" class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600">
                                        <label for="default-radio-2" class="ms-2 ml-2 text-sm font-medium text-gray-900 dark:text-gray-300">{{transEdit('coupon-exists-should-not-use')}}</label>
                                    </div>
                                </div>

                                <div v-else>
                                    <div v-if="selectedCustomerInformation.has_subvention">
                                        <i class="fa fa-check text-success"></i>
                                        {{transEdit('subvention-exists')}}
                                    </div>
                                    <div v-else>
                                        <i class="fa fa-times text-danger"></i>
                                        {{transEdit('no-subvention')}}
                                    </div>

                                    <div>
                                        {{transEdit('amount-to-pay')}}: {{formattedNumber(treatmentPriceForCustomer())}}
                                        kr.
                                    </div>

                                    <div class="mt-3" v-if="! isFreeSubvention">
                                        {{transEdit('manual-booking-information')}}
                                        <div><label><input type="checkbox" v-model="paymentReceived">
                                            {{transEdit('payment-received-confirmation')}}</label></div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div v-else-if="isLoadingCustomerData">
                            <div class="d-flex justify-content-around">
                                <div class="flex-shrink-1">
                                    <i class="flex-1 fa fa-spinner fa-spin"></i>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-else-if="isLoadingCustomers">
                        <div class="d-flex justify-content-around">
                            <div class="flex-shrink-1">
                                <i class="flex-1 fa fa-spinner fa-spin"></i>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="modal-footer">
                    <div class="flex-shrink-1">
                        <button :disabled="! canBook" class="btn btn-primary" @click="performBooking"><i
                                class="fa fa-check"></i> {{transEdit('book')}}
                        </button>
                        <button class="btn btn-dark" type="button" @click="closeModal"><i class="fa fa-ban"></i>
                            {{transEdit('cancel')}}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import VueMultiselect from "vue-multiselect/src/Multiselect";

    export default {
        name: "AdminSchedulesModalBook",
        components: {VueMultiselect},
        props: ['schedule'],
        data() {
            return {
                isLoadingCustomers: false,
                isLoadingCustomerData: false,
                customers: [],
                selectedCustomer: null,
                selectedCustomerInformation: null,
                selectedTreatment: null,
                useSubvention: false,
                paymentReceived: false,
                createNewCoupon: false,
            }
        },
        computed: {
            isFreeSubvention() {
                return this.selectedCustomerInformation && this.selectedTreatment && (this.treatmentPriceForCustomer() < 0.1);
            },
            canBook() {
                if (this.selectedCustomerInformation && this.selectedTreatment) {
                    if (this.hasCouponForTreatment) {
                        return true;
                    }

                    if (this.paymentReceived || this.isFreeSubvention) {
                        return true;
                    }
                }

                return false;
            },
            hasCouponForTreatment() {
                let self = this;
                let hasCoupon = false;

                if (this.selectedTreatment && this.selectedCustomerInformation && this.selectedCustomerInformation.coupons) {
                    let coupons = this.selectedCustomerInformation.coupons;
                    if (coupons.length > 0) {
                        coupons.forEach(function (coupon) {
                            if (coupon.treatment_id == self.selectedTreatment.id) {
                                hasCoupon = true;
                            }
                        });
                    }
                }

                return hasCoupon;
            },
        },
        watch: {
            selectedCustomer(newValue) {
                if (newValue) {
                    this.fetchCustomerInformation(newValue.id);
                } else {
                    this.selectedCustomerInformation = null;
                }
                if (this.schedule.treatments.length == 1) {
                    this.selectedTreatment = this.schedule.treatments[0];
                }
            },
            selectedTreatment(newValue) {
                this.paymentReceived = false;
            },
            schedule() {
                this.getCompanyEmployees();
            }
        },
        methods: {
            formattedNumber(number) {
                return window.number_format(number);
            },
            getPriceForSelectedTreatment() {
                let prices = this.selectedCustomerInformation.prices;
                let price = null;
                let self = this;

                prices.forEach(function (element) {
                    if (element.treatment_id == self.selectedTreatment.id) {
                        price = element;
                    }
                });

                return price;
            },
            treatmentPriceForCustomer() {
                let price = this.getPriceForSelectedTreatment();
                let vat = this.selectedTreatment.vat;

                if (this.selectedCustomerInformation.has_subvention) {
                    return price.subv_price;
                } else {
                    return price.full_price * (1 + vat / 100);
                }

            },
            performBooking() {
                let thisModal = $("#book-modal");
                let self = this;
                axios.post('adminschedule/manualbooking', {
                    'schedule_id': this.schedule.id,
                    'customer_id': this.selectedCustomer.id,
                    'treatment_id': this.selectedTreatment.id,
                    'create_new_coupon': this.hasCouponForTreatment ? this.createNewCoupon : true,
                })
                    .then(function (res) {
                        thisModal.modal('toggle');
                        self.$emit('refresh');
                    })
                    .catch(function (err) {
                      console.error(err);
                    });
            },
            fetchCustomerInformation(customerId) {
                let self = this;
                this.isLoadingCustomerData = true;
                axios.get('/adminschedule/get-customer-information', {
                    params: {
                        customer_id: customerId,
                        schedule_id: self.schedule.id,
                    }
                })
                    .then((res) => {
                        self.selectedCustomerInformation = res.data;
                        self.isLoadingCustomerData = false;
                    })
                    .catch((err) => {
                        self.isLoadingCustomerData = false;
                    });
            },
            getDate(dateString) {
                return moment(dateString).format('YYYY-MM-DD');
            },
            getDateTime(dateString) {
                return moment(dateString).format('YYYY-MM-DD') + ' kl. ' + moment(dateString).format('HH:mm')
            },
            getTime(dateString) {
                return moment(dateString).format('HH:mm')
            },
            getCompanyEmployees() {
                let self = this;
                this.isLoadingCustomers = true;
                axios.get('/adminschedule/get-company-employees', {
                    params: {
                        'schedule_id': self.schedule.id,
                    }
                })
                    .then((res) => {
                        self.customers = res.data;
                        self.isLoadingCustomers = false;
                    })
                    .catch((err) => {
                        self.isLoadingCustomers = false;
                    });
            },
            closeModal() {
                this.$emit('close');
            },
        },
    }
</script>

<style scoped>

</style>
